export default {
    id: "1",
    images: "https://image.api.playstation.com/vulcan/ap/rnd/202108/0410/D8mYIXWja8knuqYlwqcqVpi1.jpg",
    name: "《艾爾登法環》出貨突破1200萬，日本銷售破100萬",
    date: "2022年3月10日",
    intro: "《艾爾登法環》在上市一週後就創造同時線上人數突破89萬、銷量超過500萬套的驚人紀錄，宮崎英高滿滿的「善意」近期更是佔據遊戲圈所有版面。今日(3月16日)，萬代南夢宮娛樂宣布《艾爾登法環》上市不到一個月於全球銷量就累計突破1200萬套，日本國內銷量也累計超過100萬套，再次創造歷史。",
    intro2:"今日，官方也公布了遊戲總監宮崎英高的賀詞，「有這麼多人遊玩本作，讓我非常驚喜，在此僅代表製作團隊，向所有玩家致上最高的謝意。希望各位玩家可以在自喬治‧R.R‧馬丁的神話而生的廣大世界裡，享受自由度極高且滿佈威脅的冒險旅程。今後也請大家繼續支持《艾爾登法環》。」",

}






// WEBPACK FOOTER //
// ./src/database/news1.js